import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const SearchIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 20 20"
      fill="currentColor"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="search icon">
      {/* <title>search icon</title> */}
      <path d="M1.60156 19.6914L6.83594 14.457C8.22266 15.5899 9.96875 16.2149 11.875 16.2149C16.3633 16.2149 20 12.577 20 8.08986C20 3.60274 16.3621 0 11.875 0C7.38789 0 3.75 3.63751 3.75 8.08986C3.75 9.99572 4.41055 11.7442 5.50938 13.1289L0.275 18.3633C0.0898437 18.5821 0 18.8242 0 19.0625C0 19.3008 0.0915623 19.5422 0.274649 19.7254C0.640625 20.0899 1.23437 20.0899 1.60156 19.6914ZM11.875 1.87501C15.3211 1.87501 18.125 4.67892 18.125 8.12501C18.125 11.5711 15.3211 14.375 11.875 14.375C8.42891 14.375 5.625 11.5711 5.625 8.12501C5.625 4.67892 8.42969 1.87501 11.875 1.87501Z"></path>
    </svg>
  );
};

export default SearchIcon;
